import {HttpMethod} from '@/constants/httpMethod';
import {IKycUploadFileRequest} from '@/dataSource/src/api/kyc/entities';
import logError from '@/utils/errors/logError';

export const uploadFileToS3SplitBills = async (
  request: IKycUploadFileRequest,
  presignedUrl: string,
  sessionId: string,
): Promise<void> => {
  try {
    const response = await fetch(presignedUrl, {
      method: HttpMethod.PUT,
      body: request.file,
      headers: {
        'Content-MD5': request.document.content_md5,
        'x-amz-meta-session-id': sessionId,
        ...(request.userId && {'x-amz-meta-uuid': request.userId}),
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file. Status: ${response.status}`);
    }
  } catch (error) {
    logError(error, {
      customTitle: 'Mobot - Error uploading file to S3',
      fileName: 'split-bills - s3.ts',
      functionName: 'uploadFileToS3SplitBills',
    });
    throw error;
  }
};
